import { memo } from 'react';

import { Flex, Label, Text } from '@/components/core';
import { FieldConfig } from '@/components/ui';

const ISetup = () => {
  return (
    <Flex col className="p-md gap-md">
      <Flex col className="gap-sm">
        <Flex col>
          <Label>Instructions</Label>
          <Text>Define the data you want your model to extract.</Text>
        </Flex>
        <FieldConfig />
      </Flex>
    </Flex>
  );
};

export const Setup = memo(ISetup);
